// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const RELATED_WIKI_ARTICLES = "S\u00favisiace \u010dl\u00e1nky";
